import { render } from "./Sessions-list-page.vue?vue&type=template&id=ce39ff10"
import script from "./Sessions-list-page.vue?vue&type=script&lang=js"
export * from "./Sessions-list-page.vue?vue&type=script&lang=js"

import "./Sessions-list-page.vue?vue&type=style&index=0&id=ce39ff10&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__